import React from 'react';
import type { ResolvedLine } from '../../contexts/CartContext';
import { formatPrice } from '../../utils/currency';
type OrderSummaryProps = {
  lines: ResolvedLine[];
  subtotal: number;
  shipping: number;
};
export function OrderSummary({
  lines,
  subtotal,
  shipping
}: OrderSummaryProps) {
  return <div className="rounded-3xl bg-surface p-6 sm:p-8" data-id="element-18" data-mp="2hze9d4qt99p4">
      <h2 className="text-lg font-semibold" data-id="element-19" data-mp="2hws090o9um4s">Je bestelling</h2>
      <ul className="mt-5 space-y-4" data-id="element-20" data-mp="2mx69un5iu44x">
        {lines.map(l => <li key={`${l.slug}-${l.variantId}`} className="flex items-center gap-4" data-id="element-21" data-mp="2rwivj4knp55x">
            <div className="relative shrink-0" data-id="element-22" data-mp="2wnsgvsz69mc0">
              <img src={l.product.image} alt="" className="h-16 w-16 rounded-xl bg-white object-cover" data-id="element-23" data-mp="2wp3ltw4ct04p" />
              <span className="absolute -right-2 -top-2 grid h-6 min-w-6 place-items-center rounded-full bg-ink px-1.5 text-xs font-medium text-canvas" data-id="element-24" data-mp="31mc7i6opnmap">
                {l.qty}
              </span>
            </div>
            <div className="flex-1" data-id="element-25" data-mp="3antmtmuanjyc">
              <p className="text-sm font-medium" data-id="element-26" data-mp="2vbvlioiv0l25">{l.product.name}</p>
              <p className="text-sm text-muted" data-id="element-27" data-mp="2va0woz4gw8ss">{l.variant.label}</p>
            </div>
            <p className="text-sm font-medium tabular-nums" data-id="element-28" data-mp="2r98nu6zic5x1">{formatPrice(l.total)}</p>
          </li>)}
      </ul>
      <dl className="mt-6 space-y-2 border-t border-line pt-5 text-sm" data-id="element-29" data-mp="2mda2ytde161d">
        <div className="flex justify-between" data-id="element-30" data-mp="2hdx9hps0h0pt">
          <dt className="text-muted" data-id="element-31" data-mp="3ezurlm2hb418">Subtotaal</dt>
          <dd className="tabular-nums" data-id="element-32" data-mp="3ezbbmawe2ppu">{formatPrice(subtotal)}</dd>
        </div>
        <div className="flex justify-between" data-id="element-33" data-mp="3a2cinvogoot8">
          <dt className="text-muted" data-id="element-34" data-mp="35abb2n28nm9j">Verzending</dt>
          <dd className="tabular-nums" data-id="element-35" data-mp="35907an8smeif">{shipping === 0 ? <span className="font-medium text-olive" data-id="element-36" data-mp="30b84gy6m17zg">Gratis</span> : formatPrice(shipping)}</dd>
        </div>
        <div className="flex items-baseline justify-between border-t border-line pt-4" data-id="element-37" data-mp="1l81vqzw8npt">
          <dt className="font-semibold" data-id="element-38" data-mp="1n148u3h4ls0">Totaal</dt>
          <dd className="text-2xl font-semibold tabular-nums" data-id="element-39" data-mp="3sz3yfv4solsj">{formatPrice(subtotal + shipping)}</dd>
        </div>
        <p className="text-xs text-muted" data-id="element-40" data-mp="1r2ve4m2ush2j">Inclusief btw</p>
      </dl>
    </div>;
}